import { IntegrationsConfig } from "types/IntegrationConfig";
import { ACCOUNTING_PERMISSIONS } from "pages/pmt/integrations/constants";
import xeroLogo from "pages/pmt/integrations/images/integration-partner-logos/xero-logo.svg";

// Xero uses a separate PDP and setup flow. Only the marketplaceCard is used from this file.
export const xeroConfig: IntegrationsConfig = {
  numAllowedInstances: 1,
  copy: {
    marketplaceCard: {
      logoUrl: xeroLogo,
      integrationName: "Xero",
      integrationDescription:
        "Send all your paid invoices to Xero to streamline accounting processes",
      integrationCategory: "Accounting",
      requiredPermissions: ACCOUNTING_PERMISSIONS,
      slug: "xero",
      pdpUrl: "/xero/v3/settings",
    },
    pdp: {
      headerDescription: "",
      heroImageUrl: "",
      horizontalLogoUrl: "",
      resourceCard: {
        links: [],
      },
      infoTabsConfig: {},
      infoTabsContent: {
        overviewTab: {
          header: "",
          subheader: "",
          list: [
            {
              summary: "",
              detail: "",
            },
          ],
        },
      },
      disconnectModalContent: {
        title: "",
        body: <div></div>,
        disconnectButtonText: "",
      },
      allowedPdpActions: [],
    },
    setup: {
      estimatedSetupTime: "",
      helpCenterLink: "",
      stepperConfig: {},
      steps: [],
      instanceKeys: [],
      getCurrentStepFunction: () => 0,
    },
  },
};
